export default __webpack_public_path__ + "static/media/m_wdt_c_3.225d60e2.mp3";